// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__VC924","header":"MergedInvoice_header__2HHde"};